import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-2 w-full" }
const _hoisted_2 = { class: "flex flex-col gap-y-2 col-span-2" }
const _hoisted_3 = { class: "flex flex-col gap-y-2" }
const _hoisted_4 = { class: "flex flex-col gap-y-2" }
const _hoisted_5 = { class: "flex flex-col gap-y-2" }
const _hoisted_6 = { class: "flex flex-col gap-y-2" }
const _hoisted_7 = { class: "flex flex-col gap-y-2 col-span-2" }
const _hoisted_8 = { class: "flex flex-col gap-y-2" }
const _hoisted_9 = { class: "flex flex-col gap-y-2" }
const _hoisted_10 = { class: "flex flex-col gap-y-2 col-span-2" }
const _hoisted_11 = { class: "flex flex-col gap-y-2" }
const _hoisted_12 = { class: "flex flex-col gap-y-2" }
const _hoisted_13 = { class: "flex items-center gap-x-2" }
const _hoisted_14 = { class: "flex flex-col gap-y-2" }
const _hoisted_15 = { class: "flex flex-col gap-y-2" }
const _hoisted_16 = { class: "flex flex-col gap-y-2" }
const _hoisted_17 = { class: "flex flex-col gap-y-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "grid grid-cols-2 gap-3 p-3 col-span-2",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "grid grid-cols-2 gap-3 p-3 col-span-2",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          width: "35%",
          height: "1.5rem",
          class: "col-span-2"
        }),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "3.5rem"
          })
        ]),
        _createVNode(_component_Skeleton, {
          width: "35%",
          height: "1.2rem",
          class: "col-span-2"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "grid grid-cols-2 gap-3 p-3 col-span-2",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          width: "35%",
          height: "1.5rem",
          class: "col-span-2"
        }),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "3.5rem"
          })
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Skeleton, {
            width: "20%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "20%",
            height: "1.2rem"
          })
        ]),
        _createVNode(_component_Skeleton, {
          width: "35%",
          height: "1.2rem",
          class: "col-span-2"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "flex flex-col gap-3 p-3",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          width: "55%",
          height: "1.5rem",
          class: "col-span-2"
        }),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "flex flex-col gap-3 p-3",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          width: "55%",
          height: "1.5rem",
          class: "col-span-2"
        }),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "grid grid-cols-2 gap-3 p-3 col-span-2",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          width: "35%",
          height: "1.5rem",
          class: "col-span-2"
        }),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Skeleton, {
            width: "35%",
            height: "1.2rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "2rem"
          })
        ])
      ]),
      _: 1
    })
  ]))
}